import SectionLabel from "../../../components/SectionLabel";
import SchematicFloorplan from "../../../components/private/SchematicFloorplan";

export default function SchematicSection({ schematic }) {
    return (
        <section className="bg-[#0B0B0C] overflow-hidden">
            <div className="shell py-20 md:py-28">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 items-start">
                    <div className="lg:col-span-4">
                        <SectionLabel number="03" label="Schematic" />
                        <h2 className="mt-8 font-serif text-3xl md:text-4xl leading-[1.1]">
                            A conceptual{" "}
                            <span className="italic text-[#C9A86A]">
                                plate.
                            </span>
                        </h2>
                        <p className="mt-6 text-[#9A958A] text-[15px] leading-[1.85]">
                            The schematic below is a stylized rendering
                            for editorial purposes only — not to scale,
                            not drawn from a survey. It indicates the
                            rough topology of principal systems across
                            the floorplate.
                        </p>
                    </div>
                    <div className="lg:col-span-8">
                        <SchematicFloorplan
                            title={schematic.title}
                            caption={schematic.caption}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
